export const ALL_LANGUAGES_KEYS = [
  'arabic',
  'belarusian',
  'bulgarian',
  'catalan',
  'chineseSimpl',
  'chineseTrad',
  'croatian',
  'czech',
  'danish',
  'dutch',
  'english',
  'estonian',
  'finnish',
  'french',
  'frenchCan',
  'galician',
  'german',
  'greek',
  'hebrew',
  'hindi',
  'hungarian',
  'indonesian',
  'italian',
  'japanese',
  'korean',
  'latvian',
  'lithuanian',
  'malay',
  'norwegian',
  'polish',
  'portuguese',
  'portugueseBraz',
  'romanian',
  'russian',
  'slovak',
  'slovenian',
  'spanish',
  'spanichMex',
  'swahili',
  'swedish',
  'tamil',
  'thai',
  'turkish',
  'ukrainian',
  'urdu',
  'vietnamese',
  'welsh',
];

export const LOCALE_TO_KEY_MAP: Record<string, string> = {
  en: 'english',
  'en-US': 'english',
  'en-GB': 'english',

  es: 'spanish',
  'es-MX': 'spanichMex',
  ru: 'russian',
  fr: 'french',
  'fr-CA': 'frenchCan',
  de: 'german',
  it: 'italian',
  pt: 'portuguese',
  'pt-PT': 'portuguese',
  'pt-BR': 'portugueseBraz',

  zh: 'chineseSimpl',
  'zh-CN': 'chineseSimpl',
  'zh-TW': 'chineseTrad',
  'zh-HK': 'chineseTrad',

  ja: 'japanese',
  ko: 'korean',
  ar: 'arabic',
  hi: 'hindi',
  ur: 'urdu',
  he: 'hebrew',
  id: 'indonesian',
  ms: 'malay',
  th: 'thai',
  vi: 'vietnamese',
  nl: 'dutch',
  sv: 'swedish',
  da: 'danish',
  no: 'norwegian',
  nb: 'norwegian',
  nn: 'norwegian',
  fi: 'finnish',
  pl: 'polish',
  cs: 'czech',
  sk: 'slovak',
  hu: 'hungarian',
  ro: 'romanian',
  bg: 'bulgarian',
  hr: 'croatian',
  sr: 'serbian',
  sl: 'slovenian',
  el: 'greek',
  uk: 'ukrainian',
  be: 'belarusian',
  ca: 'catalan',
  gl: 'galician',
  cy: 'welsh',
  sw: 'swahili',
  ta: 'tamil',
  tr: 'turkish',
  et: 'estonian',
  lv: 'latvian',
  lt: 'lithuanian',
};

export const LANGUAGE_KEY_TO_LOCALE: Record<string, string> = {
  arabic: 'ar',
  belarusian: 'be',
  bulgarian: 'bg',
  catalan: 'ca',
  chineseSimpl: 'zh',
  chineseTrad: 'zh-TW',
  croatian: 'hr',
  czech: 'cs',
  danish: 'da',
  dutch: 'nl',
  english: 'en',
  estonian: 'et',
  finnish: 'fi',
  french: 'fr',
  frenchCan: 'fr-CA',
  galician: 'gl',
  german: 'de',
  greek: 'el',
  hebrew: 'he',
  hindi: 'hi',
  hungarian: 'hu',
  indonesian: 'id',
  italian: 'it',
  japanese: 'ja',
  korean: 'ko',
  latvian: 'lv',
  lithuanian: 'lt',
  malay: 'ms',
  norwegian: 'no',
  polish: 'pl',
  portuguese: 'pt',
  portugueseBraz: 'pt-BR',
  romanian: 'ro',
  russian: 'ru',
  slovak: 'sk',
  slovenian: 'sl',
  spanish: 'es',
  spanichMex: 'es-MX',
  swahili: 'sw',
  swedish: 'sv',
  tamil: 'ta',
  thai: 'th',
  turkish: 'tr',
  ukrainian: 'uk',
  urdu: 'ur',
  vietnamese: 'vi',
  welsh: 'cy',
};

// Часть языков на нашем бэке (GET /languages) имеет коды, отличные от локалей выше
export const LANGUAGE_KEY_TO_API_CODE: Record<string, string> = {
  chineseSimpl: 'zh-hans',
  chineseTrad: 'zh-hant',
};
